import { render, staticRenderFns } from "./ATWrapper.vue?vue&type=template&id=8a852e4a&"
import script from "./ATWrapper.vue?vue&type=script&lang=js&"
export * from "./ATWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports